import React from "react";
import {
  INFIPIONT_URL,
  UploadDocumentsConstants as UDC,
} from "../../utils/const";

const Instructions = () => {
  const instructionsWithLink = UDC.instructions
    .split("\n")
    .map((line, index) => {
      const parts = line.split(/(Infopoint)/g); // Разбить строку на части, выделив слово "Infopoint"
      return (
        <div key={index}>
          {parts.map((part, i) =>
            part === "Infopoint" ? (
              <a
                key={i}
                href={INFIPIONT_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                {part}
              </a>
            ) : (
              <span key={i}>{part}</span>
            )
          )}
        </div>
      );
    });

  return <div>{instructionsWithLink}</div>;
};

export default Instructions;
